class Weglot {
    static async search(words, languageTo, callback) {
        try {
            /*const tranlatedObject: WeglotInput= {
            'words':words.map(word => ({"t":1, "w": word})),
            'languageTo':languageTo
            };*/
            const searchTerm = words && words.length > 0 ? words[0] : '';
            return await window?.Weglot.search(searchTerm, callback);
        }
        catch (e) {
            console.error({ msg: 'cannot translate using weglot', params: { words: words, languageTo: languageTo },
                WeglotInput: {
                    'words': words.map(word => ({ "t": 1, "w": word })),
                    'languageTo': languageTo
                },
                Weglot: window?.Weglot,
                e: e });
            return words;
        }
    }
    static async translate(words, languageTo) {
        try {
            const tranlatedObject = {
                'words': words.map(word => ({ "t": 1, "w": word })),
                'languageTo': languageTo
            };
            await window?.Weglot.translate(tranlatedObject, async (result) => { return result; });
        }
        catch (e) {
            console.error({ msg: 'cannot translate using weglot', params: { words: words, languageTo: languageTo },
                WeglotInput: {
                    'words': words.map(word => ({ "t": 1, "w": word })),
                    'languageTo': languageTo
                },
                Weglot: window?.Weglot,
                e: e });
            return words;
        }
    }
    static getCurrentLanguage() {
        try {
            return (window?.Weglot?.getCurrentLang()) ?? 'en';
        }
        catch (e) {
            console.error({ msg: 'cannot get language using Weglot'
            });
        }
    }
}
export { Weglot };
//# sourceMappingURL=Weglot.js.map